import { render, staticRenderFns } from "./ContactBubble.vue?vue&type=template&id=7086b444&scoped=true&"
import script from "./ContactBubble.vue?vue&type=script&lang=js&"
export * from "./ContactBubble.vue?vue&type=script&lang=js&"
import style0 from "./ContactBubble.vue?vue&type=style&index=0&id=7086b444&scoped=true&lang=scss&"
import style1 from "./ContactBubble.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086b444",
  null
  
)

export default component.exports